<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute bg-color"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    :style="headerImage"
  >
    <div
      style="width:100%; display: flex; justify-content: space-between; align-items: center;"
      class="md-collapse-lateral"
    >
      <div style="flex-shrink: 0;" class="md-toolbar-section-start">
        <md-button
          style="margin-right: 10px;"
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span style="color: #1565c0 !important;" class="icon-bar"></span>
          <span style="color: #1565c0 !important;" class="icon-bar"></span>
          <span style="color: #1565c0 !important;" class="icon-bar"></span>
        </md-button>
        <router-link style="display: flex; align-items: center;" to="/">
          <img
            width="auto"
            :src="icons.LogoGmaths"
            alt=""
            class="mr-10"
            style="width: 100%; max-height: 45px;margin-right:10px;"
          />
          <h4 style="color: #004390 !important; font-weight: 700; margin: 0;">
            GMaths
          </h4>
        </router-link>
      </div>

      <div class="md-toolbar-section-end">
        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list class="lang-pc">
              <md-list-item
                :class="{ 'item-menu-active': isActive == menus.study }"
                @click="
                  () => {
                    this.isActive = menus.study;
                  }
                "
                class="item-menu"
                to="/grade"
              >
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <span class="text-lang">{{ menus.study }}</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
              <!-- <md-list-item
                :class="{ 'item-menu-active': isActive == menus.tutor }"
                @click="
                  () => {
                    this.isActive = menus.tutor;
                  }
                "
                class="item-menu"
              >
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang"> {{ menus.tutor }}</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
              <md-list-item
                class="item-menu"
                :class="{ 'item-menu-active': isActive == menus.examination }"
                @click="
                  () => {
                    this.isActive = menus.examination;
                  }
                "
              >
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang"> {{ menus.examination }}</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item> -->
              <md-list-item
                class="item-menu"
                to="/pack-data"
                :class="{ 'item-menu-active': isActive == menus.package }"
                @click="
                  () => {
                    this.isActive = menus.package;
                  }
                "
              >
                <p class="text-menu">{{ menus.package }}</p>
              </md-list-item>
              <md-list-item
                class="item-menu"
                to="/about-us"
                :class="{ 'item-menu-active': isActive == menus.introduce }"
                @click="
                  () => {
                    this.isActive = menus.introduce;
                  }
                "
              >
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <span class="text-lang">{{ menus.introduce }}</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
            </md-list>
            <md-list class="mobile">
              <md-list-item @click="toggleNavbarMobile" to="/grade">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang">Học tập</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
              <!-- <md-list-item
                @click="toggleNavbarMobile"
                href="https://app.mobimath.vn"
              >
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang">Gia sư</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
              <md-list-item
                @click="toggleNavbarMobile"
                href="https://app.mobimath.vn"
              >
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang">Thi cử</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item> -->
              <md-list-item @click="toggleNavbarMobile" to="/pack-data">
                <p class="text-menu">
                  Gói cước
                </p>
              </md-list-item>
              <md-list-item @click="toggleNavbarMobile" to="/about-us" >
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="text-lang"> {{ menus.introduce }}</span>
                    <img :src="icons.CaretIcon" alt="" />
                  </span>
                </el-dropdown>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
      <div class="md-toolbar-section-end lang-pc">
        <div
          style="display: flex;     align-items: center;
        "
        >
          <div v-if="!userInfo">
            <el-button @click="handleLogin" class="btn-login">
              Đăng nhập
            </el-button>
            <el-button @click="handleRegister" class="btn-login">
              Đăng ký
            </el-button>
          </div>
          <div style="display: flex; align-items: center;" v-else>
            <p
              style="color: #1565c0; margin:2px 10px 0 0;  font-weight: 700;font-size: 16px;"
            >
              👋 Chào {{ userInfo.fullname }}
            </p>
            <div class="">
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <img :src="icons.UserIcon" alt="" />
                </span>
                <el-dropdown-menu style="width: 150px;" slot="dropdown">
                  <el-dropdown-item>
                    <p class="text-login-mobile">
                      Thông tin
                    </p>
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleLogout">
                    <p @click="handleLogout" class="text-login-mobile">
                      Đăng xuất
                    </p>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <el-dropdown
            style="margin-left: 10px;"
            trigger="click"
            @command="handleCommand"
          >
            <span class="el-dropdown-link">
              <img :src="icons.LanguageIcon" alt="" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="lang in languages"
                :key="lang.title"
                :value="lang.language"
                :command="lang.language"
              >
                <flag :iso="lang.flag" v-bind:squared="false" />
                <span class="text-lang-item">{{
                  lang.flag
                }}</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div
        style=" text-align: right;min-width: 180px; "
        class="md-toolbar-section-end mobile"
      >
        <div>
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <img :src="icons.LoginIcon" alt="" />
            </span>
            <el-dropdown-menu
              v-if="!userInfo"
              style="width: 150px;"
              slot="dropdown"
            >
              <el-dropdown-item @click="handleLogin">
                <p @click="handleLogin" class="text-login-mobile">Đăng nhập</p>
              </el-dropdown-item>
              <el-dropdown-item @click="handleRegister">
                <p @click="handleRegister" class="text-login-mobile">Đăng ký</p>
              </el-dropdown-item>
            </el-dropdown-menu>
            <el-dropdown-menu v-else style="width: 150px;" slot="dropdown">
              <el-dropdown-item>
                <p class="text-login-mobile">Thông tin</p>
              </el-dropdown-item>
              <el-dropdown-item @click="handleLogout">
                <p @click="handleLogout" class="text-login-mobile">Đăng xuất</p>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
import { getToken, setupLoginWap } from "@/utils/auth.js";
// import CaretIcon from "@/assets/img/svg/caret.svg";
import i18n from "@/plugins/i18n";
import LanguageIcon from "@/assets/img/svg/language.svg";
import UserIcon from "@/assets/img/svg/user_icon.svg";

// import LoginIcon from "@/assets/img/svg/login.svg";
// import LogoMibiFone from "@/assets/img/svg/logo-mobifone.svg";
// import LogoGmaths from "@/assets/img/svg/Gmaths.svg";

import { getInfo } from "../../utils/auth";
import { getBackGround, setFlag, setLanguage } from "../../utils/wapAuth";

const BASE_APP_MOBIMATH = "https://app.mobimath.vn/ ";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      isActive: null,
      menus: {
        study: "Học tập",
        package: "Gói cước",
        tutor: "Gia sư",
        examination: "Thi cử",
        introduce: "Giới thiệu"
      },
      userInfo: getInfo(),
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      headerImage: {
        background: getBackGround()?.headerImage
          ? `url(${getBackGround()?.headerImage})`
          : "#ECEFF8" + "!important",
        paddingTop: " 10px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "auto",
        backgroundAttachment: "fixed",
        backgroundSize: "100% 100%"
      },
      icons: {
        // CaretIcon,
        LanguageIcon,
        // LoginIcon,
        // LogoMibiFone,
        // UserIcon,
        // LogoGmaths
      },
      languages: [
        { flag: "us", language: "en", title: "English" },
        { flag: "vn", language: "vi", title: "Tiếng Việt" },
        { flag: "th", language: "th", title: "Thái Lan" }
      ],
      locale: localStorage.getItem("flag")
    };
  },
  created() {
    // setupLoginWap(this);
    this.extraNavClasses = `md-white`;
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["login", "landing", "profile"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    showLogin() {
      return !getInfo();
      // return !window.localStorage.getItem("token");
    }
  },
  methods: {
    // bodyClick() {
    //   let bodyClick = document.getElementById("bodyClick");

    //   if (bodyClick === null) {
    //     let body = document.querySelector("body");
    //     let elem = document.createElement("div");
    //     elem.setAttribute("id", "bodyClick");
    //     body.appendChild(elem);

    //     let bodyClick = document.getElementById("bodyClick");
    //     bodyClick.addEventListener("click", this.toggleNavbarMobile);
    //   } else {
    //     bodyClick.remove();
    //   }
    // },
    // handleLogin() {
    //   console.log("đã vào đây");
    //   window.open(BASE_APP_MOBIMATH, "_blank");
    // },

    handleLogin() {
      this.$store.dispatch("showLoginDialog");
    },
    handleLogout() {
      window.localStorage.clear("info");
      window.location.reload();
    },
    handleRegister() {
      this.$store.dispatch("showRegisterDialog");
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
    },
    handleCommand(command) {
      i18n.locale = command;
      // localStorage.setItem("language", command);
      setLanguage(command);
      if (command === "en") {
        this.locale = "us";
        // localStorage.setItem("flag", "us");
        setFlag("us");
      } else if (command === "vi") {
        this.locale = "vn";
        // localStorage.setItem("flag", "vn");
        setFlag("vn");
      } else {
        this.locale = command;
        // localStorage.setItem("flag", command);
        setFlag("command");
      }
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style scoped>
.text-login-mobile {
  padding: 0;
  margin: 0;
  color: #1565c0;
  font-weight: 600;
  font-size: 17px;
}
.item-menu-active {
  border-radius: 100px;
  background: #cad9ef;
}
.item-menu:hover {
  border-radius: 100px;
  background: #cad9ef;
}
.item-menu button {
  border-radius: 100px !important;
}
.item-menu button:hover {
  border-radius: 100px;
  background: #cad9ef !important;
}
.item-menu button:hover .text-lang {
}
.btn-login {
  border-radius: 100px;
  color: #1565c0;
  border-color: #cad9ef;
}
.mobile {
  display: none;
}
.lang-mobile {
  display: none;
}

.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.text-lang {
  color: #1565c0;
  padding-left: 4px;
  font-weight: 600;
  text-transform: capitalize !important;
}
.text-menu {
  color: #1565c0 !important;
  padding-left: 4px !important;
  font-weight: 600 !important;
  text-transform: capitalize !important;
  font-size: 14px !important;
}
.text-lang-item {
  padding-left: 4px;
  text-transform: uppercase;
}
.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
  .md-collapse-lateral .md-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    left: -500px;
    z-index: 1032;
    visibility: visible;
    background-color: #1565c0;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .md-collapse-lateral .md-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    display: block;
    background-color: #1565c0 !important;
    content: "";
    z-index: 1;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .text-lang {
    color: #ffff;
    font-weight: 500;
    text-transform: capitalize !important;
  }
  .text-menu {
    color: #ffff !important;
    font-weight: 500 !important;
    text-transform: capitalize !important;
    font-size: 14px !important;
  }
  .md-collapse::before {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    left: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #1565c0 !important;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .lang-mobile {
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
